import React from "react";
import { ExpressServiceIcon } from "../../../components/Icons";

interface IReasonForVisitCard{
  icon?: JSX.Element;
  title: string;
  value: string;
  isSelected:boolean;
  onCardClick?: (value: string) => void | null;
  iconColor?: string;
}

const ReasonForVisitCard = ({ icon, title, value, onCardClick, isSelected, iconColor }: IReasonForVisitCard) => {
  const onCardSelection = ()=>{
    onCardClick && onCardClick(value);
  };


  return (
    <div
      onClick={onCardSelection}
      className={`capitalize cursor-pointer w-full rounded-lg border border-taupe-50
      p-4 flex flex-col gap-2 items-center bg-white ${isSelected ?
      "!bg-gv-yellow-light !border-gv-yellow" : ""}`}>
      <div className={`${iconColor ? iconColor : "bg-taupe-3"} rounded-full p-2`}>
        {icon ? icon : <ExpressServiceIcon />}
      </div>
      <div className="text-center text-sm font-semibold w-3/4">
        {title}
      </div>
    </div>
  );
};

export default ReasonForVisitCard;
